

import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { GoldAndRum_Responsive } from "../GoldAndRum/game_responsive";

export class GoldAndRumLink_Responsive extends GoldAndRum_Responsive {
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "GoldAndRumLink");
    }
}